import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {Boxed} from "../../../hiberUiKit/src/molecules/Boxed/Boxed";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import Routes from "../../../navigation/route/Route";
import CreatePartnerBrandForm from "./form/create/CreatePartnerBrandForm";

type Props = RouteComponentProps<any>;

/**
 * Create partner brand.
 */
class PartnerBrandCreate extends React.PureComponent <Props, {}> {

	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Create new partner brand"}/>
				<PageContentView>
					<CreatePartnerBrandForm onSuccess={this.onSuccess} onCancel={this.onCancel}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On successfully added partner brand.
	 */
	private onSuccess() {
		this.props.history.push(Routes.PartnerBrandList);
	}

	/**
	 * On cancel click.
	 * Redirect to previous page.
	 */
	private onCancel() {
		this.props.history.goBack();
	}
}

export default withRouter(PartnerBrandCreate);